import initialState from '../initial-state/domainData';
import update from '../../public/utils/immutable-update';
import {
    LOGOUT_ACTION,

    PATCH_ACTION,
    SAVE_COMPARATIVE_DATA,
    SAVE_COMPARATIVE_VIEW,
    SET_ACTIVE_COMPARATIVE_VIEW,

    SET_CURRENT_TIME,
    SET_CURRENT_DATE,

    SET_ACTIVE_EQUITY,
    SAVE_EQUITY_FINANCIALS,
    SAVE_EQUITY_TIME_SERIES,
    SAVE_EQUITY_TEARSHEET,
    SAVE_EQUITY_PRICE_ACTIONS,
    SAVE_EQUITY_KEY_FINANCIALS,
    SAVE_EQUITY_ANNOUNCEMENT,
    SAVE_EQUITY_DIVIDEND_HISTORY,

    SAVE_TICKERS_DETAIL,

    SET_ANNOUNCEMENT_AGM_SGM,
    SET_ANNOUNCEMENT_AUCTION,
    SET_ANNOUNCEMENT_BOND_DEBENTURE,
    SET_ANNOUNCEMENT_DIVIDEND,
    SET_ANNOUNCEMENT_FINANCIALS,
    SET_ANNOUNCEMENT_IPO_FPO,
    SET_ANNOUNCEMENT_NEPSE_CIRCULAR,
    SET_ANNOUNCEMENT_RIGHT_SHARES,

    SET_OVERVIEW_ACTIVE_SECTOR,
    SAVE_OVERVIEW_INDICES_DATA,
    SAVE_OVERVIEW_PRICE_ACTIONS,
    SAVE_OVERVIEW_TOP_BROKERS,
    SAVE_OVERVIEW_TOP_LOSERS_GAINERS,
    SAVE_OVERVIEW_ACTIVE_TURNOVER,
    SAVE_OVERVIEW_TIME_SERIES,
    SAVE_OVERVIEW_SECTOR_DATA,

    SAVE_HOMESCREEN_TODAYS_EVENTS,
    SAVE_HOMESCREEN_TODAYS_ANNOUNCEMENT,
    SAVE_HOMESCREEN_UPCOMING_EVENTS,
    SAVE_HOMESCREEN_MOVERS,
    SAVE_HOMESCREEN_PORTFOLIO,

    SAVE_HOMESCREEN_WATCHLIST_TICKERS,
    SAVE_HOMESCREEN_WATCHLIST,
} from '../action-types/domainData';

const logout = () => initialState;

const patchData = (state, action) => {
    // TODO: Add useful functionality here
    const settings = {
        scene: {
            $set: action.scene,
        },
    };
    return update(state, settings);
};

// Ticker Detail

const saveTickersDetail = (state, action) => {
    const tickerDetail = {};
    const tickerDetailSectorMap = {};
    const tickerDetailSector = [];

    action.tickersDetail.forEach((ele) => {
        tickerDetail[ele.ticker] = {
            fullName: ele.companyName,
            sector: ele.sector,
            ticker: ele.ticker,
        };
        if (tickerDetailSectorMap[ele.sector]) {
            tickerDetailSectorMap[ele.sector].push(ele.ticker);
        } else {
            tickerDetailSectorMap[ele.sector] = [ele.ticker];
        }
    });

    Object.keys(tickerDetailSectorMap).forEach((sector) => {
        tickerDetailSector.push({
            sector,
            tickers: tickerDetailSectorMap[sector],
        });
    });

    const settings = {
        tickerDetail: { $set: tickerDetail },
        tickerDetailSector: { $set: tickerDetailSector },
    };
    return update(state, settings);
};

// Announcement

const saveAnnouncementAgmSgm = (state, action) => {
    const settings = {
        announcements: {
            agmSgm: {
                $autoArray: {
                    $set: action.agmSgm,
                },
            },
        },
    };
    return update(state, settings);
};

const saveAnnouncementAuction = (state, action) => {
    const settings = {
        announcements: {
            auction: {
                $autoArray: {
                    $set: action.auction,
                },
            },
        },
    };
    return update(state, settings);
};

const saveAnnouncementBondDebenture = (state, action) => {
    const settings = {
        announcements: {
            bondDebenture: {
                $autoArray: {
                    $set: action.bondDebenture,
                },
            },
        },
    };
    return update(state, settings);
};

const saveAnnouncementDividend = (state, action) => {
    const settings = {
        announcements: {
            dividend: {
                $autoArray: {
                    $set: action.dividend,
                },
            },
        },
    };
    return update(state, settings);
};

const saveComparativeActiveView = (state, action) => {
    const settings = {
        comparativeActiveViewId: {
            $set: action.view,
        },
    };
    return update(state, settings);
};

const saveAnnouncementFinancials = (state, action) => {
    const settings = {
        announcements: {
            financials: {
                $autoArray: {
                    $set: action.financials,
                },
            },
        },
    };
    return update(state, settings);
};

const saveAnnouncementIpoFpo = (state, action) => {
    const settings = {
        announcements: {
            ipoFpo: {
                $autoArray: {
                    $set: action.ipoFpo,
                },
            },
        },
    };
    return update(state, settings);
};

const saveAnnouncementNepseCircular = (state, action) => {
    const settings = {
        announcements: {
            nepseCircular: {
                $autoArray: {
                    $set: action.nepseCircular,
                },
            },
        },
    };
    return update(state, settings);
};

const saveAnnouncementRightShares = (state, action) => {
    const settings = {
        announcements: {
            rightShares: {
                $autoArray: {
                    $set: action.rightShares,
                },
            },
        },
    };
    return update(state, settings);
};


// Comparative

// TODO: add $auto and $autoArray
const saveComparativeView = (state, action) => {
    const { view, criteria, securities, pristine } = action;
    const settings = {
        comparativeView: { $auto: {
            [view]: { $auto: {
                pristine: {
                    $set: pristine === undefined ? true : pristine,
                },
            } },
        } },
    };

    if (securities) {
        settings.comparativeView.$auto[view].$auto.securities = { $autoArray: {
            $set: securities,
        } };
    }

    if (criteria) {
        settings.comparativeView.$auto[view].$auto.criteria = { $autoArray: {
            $set: criteria,
        } };
    }

    return update(state, settings);
};

const saveComparativeData = (state, action) => {
    const comparativeData = {};

    action.comparativeData.forEach((ele) => {
        const newEle = {};
        Object.keys(ele).forEach((key) => {
            if (typeof ele[key] === 'object') {
                Object.keys(ele[key]).forEach((childKey) => {
                    newEle[`${key}__${childKey}`] = ele[key][childKey];
                });
            } else {
                newEle[key] = ele[key];
            }
        });
        comparativeData[ele.ticker] = {
            $auto: { $set: newEle },
        };
    });

    const settings = {
        comparativeData: {
            [action.view]: { $auto: comparativeData },
        },
    };

    return update(state, settings);
};

// Equity

const saveActiveEquity = (state, action) => {
    const settings = {
        equityActiveTicker: {
            $set: action.ticker,
        },
    };
    return update(state, settings);
};

// Equity Financial

const saveEquityFinancial = (state, action) => {
    // SMTM API for equity financial can give different field name
    // Fixing MySqlColumnName/MysqlColumnName
    const fixedFormat = action.format ? action.format.reduce((acc, format) => {
        acc.push({
            ...format,
            MySqlColumnName: format.MySqlColumnName ?
                format.MySqlColumnName : format.MysqlColumnName,
        });
        return acc;
    }, []) : [];
    const settings = {
        equityFinancials: {
            [action.ticker]: { $auto: {
                [action.financialType]: { $auto: {
                    data: { $autoArray: { $set: action.data } },
                    format: { $autoArray: { $set: fixedFormat } },
                } },
            } },
        },
    };
    return update(state, settings);
};

const saveEquityTimeSeries = (state, action) => {
    const settings = {
        equityTimeSeries: {
            [action.ticker]: { $auto: {
                [action.timeInterval]: { $autoArray: {
                    $set: action.timeSeriesData.sort((a, b) => a.timeStamp - b.timeStamp),
                } },
            } },
        },
    };
    return update(state, settings);
};

// Equity Tearsheet

const saveEquityTearsheet = (state, action) => {
    const settings = {
        equityTearsheet: {
            [action.ticker]: { $auto: {
                dataType: { $set: action.dataType },
                data: { $auto: {
                    $merge: action.tearsheetData,
                } },
            } },
        },
    };
    return update(state, settings);
};

const saveEquityPriceActions = (state, action) => {
    const { ticker, data } = action;
    const settings = {
        priceActions: {
            [ticker]: { $autoArray: {
                $set: data.sort((a, b) => b.timestamp - a.timestamp),
            } },
        },
    };
    return update(state, settings);
};

const saveEquityKeyFinancial = (state, action) => {
    const settings = {
        equityKeyFinancials: {
            [action.ticker]: { $autoArray: {
                $set: action.keyFinancials,
            } },
        },
    };
    return update(state, settings);
};

const saveEquityAnnouncement = (state, action) => {
    const settings = {
        equityAnnouncements: {
            [action.ticker]: { $autoArray: {
                $set: action.announcement,
            } },
        },
    };
    return update(state, settings);
};

const saveEquityDividentHistory = (state, action) => {
    const settings = {
        equityDividendHistory: {
            [action.ticker]: { $autoArray: {
                $set: action.dividentHistory,
            } },
        },
    };
    return update(state, settings);
};

const setOverviewActiveSector = (state, action) => {
    const settings = {
        overviewActiveSector: {
            $set: action.sector,
        },
    };

    return update(state, settings);
};

const saveOverviewSectorData = (state, action) => {
    const { sector, data } = action;

    const settings = {
        sectors: { $auto: {
            [sector]: { $auto: {
                $merge: data,
            } },
        } },
    };

    return update(state, settings);
};

const saveOverviewIndicesData = (state, action) => {
    const sectorEntries = Object.keys(action.data);
    const settings = {};

    settings.sectors = sectorEntries.reduce((arr, key) => ({
        ...arr,
        [key]: { $auto: {
            $merge: {
                pc: action.data[key],
            },
        } },
    }), {});

    settings.sectorEntry = { $autoArray: {
        $set: sectorEntries,
    } };

    return update(state, settings);
};

const saveOverviewPriceActions = (state, action) => {
    const settings = {
        marketNotifications: { $autoArray: {
            $set: action.data.sort((a, b) => b.timestamp - a.timestamp),
        } },
    };
    return update(state, settings);
};

const saveOverviewTopBrokers = (state, action) => {
    const settings = {
        topBrokers: { $autoArray: {
            $set: action.data,
        } },
    };
    return update(state, settings);
};

const saveOverviewTopLosersGainers = (state, action) => {
    const { losers, gainers } = action;
    const settings = {};

    if (gainers) {
        settings.topGainers = { $autoArray: {
            $set: gainers,
        } };
    }
    if (losers) {
        settings.topLosers = { $autoArray: {
            $set: losers,
        } };
    }

    return update(state, settings);
};

const saveOverviewActiveTurnover = (state, action) => {
    const { mostActive, highestTurnover } = action;
    const settings = {};

    if (mostActive) {
        settings.mostActive = { $autoArray: {
            $set: mostActive,
        } };
    }
    if (highestTurnover) {
        settings.highestTurnover = { $autoArray: {
            $set: highestTurnover,
        } };
    }

    return update(state, settings);
};

const saveOverviewTimeSeries = (state, action) => {
    const { lineChart, barChart, sectorType, interval } = action;

    const settings = {
        overviewTimeSeries: { $auto: {
            [sectorType]: { $auto: {
                lineChart: { $auto: {
                    [interval]: { $autoArray: {
                        $set: lineChart.sort((a, b) => a.timeStamp - b.timeStamp),
                    } },
                } },
                barChart: { $auto: {
                    [interval]: { $autoArray: {
                        $set: barChart.sort((a, b) => a.timeStamp - b.timeStamp),
                    } },
                } },
            } },
        } },
    };

    return update(state, settings);
};

// HomeScreen

const saveHomeScreenTodaysEvents = (state, action) => {
    const settings = {
        todaysEvents: { $autoArray: {
            $set: action.data,
        } },
    };

    return update(state, settings);
};

const saveHomeScreenTodaysAnnouncements = (state, action) => {
    const settings = {
        todayAnnouncements: { $autoArray: {
            $set: action.data,
        } },
    };

    return update(state, settings);
};

const saveHomeScreenUpcomingEvents = (state, action) => {
    const settings = {
        upcomingEvents: { $autoArray: {
            $set: action.data,
        } },
    };

    return update(state, settings);
};

const saveHomeMovers = (state, action) => {
    const { gainers, losers } = action;

    const settings = {
        movers: { $auto: {
            gainers: { $autoArray: {
                $set: gainers,
            } },
            losers: { $autoArray: {
                $set: losers,
            } },
        } },
    };

    return update(state, settings);
};

const saveHomePortfolio = (state, action) => {
    const settings = {
        portfolio: { $autoArray: {
            $set: action.data,
        } },
    };

    return update(state, settings);
};

const saveWatchListTickers = (state, action) => {
    const settings = {
        watchlistTickers: { $autoArray: {
            $set: [...new Set(action.data)], // unique tickers
        } },
    };

    return update(state, settings);
};

const saveWatchList = (state, action) => {
    const settings = {
        watchlist: { $autoArray: {
            $set: action.data,
        } },
    };

    return update(state, settings);
};

const setCurrentDate = (state, action) => {
    const settings = {
        currentDate: {
            $set: action.timeStamp,
        },
    };

    return update(state, settings);
};

const setCurrentTime = (state, action) => {
    const settings = {
        currentTime: {
            $set: action.timeStamp,
        },
    };

    return update(state, settings);
};

const domainDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGOUT_ACTION:
            return logout(state, action);

        case PATCH_ACTION:
            return patchData(state, action);
        case SAVE_TICKERS_DETAIL:
            return saveTickersDetail(state, action);

        case SET_CURRENT_TIME:
            return setCurrentTime(state, action);
        case SET_CURRENT_DATE:
            return setCurrentDate(state, action);

        case SET_ANNOUNCEMENT_AGM_SGM:
            return saveAnnouncementAgmSgm(state, action);
        case SET_ANNOUNCEMENT_AUCTION:
            return saveAnnouncementAuction(state, action);
        case SET_ANNOUNCEMENT_BOND_DEBENTURE:
            return saveAnnouncementBondDebenture(state, action);
        case SET_ANNOUNCEMENT_DIVIDEND:
            return saveAnnouncementDividend(state, action);
        case SET_ANNOUNCEMENT_FINANCIALS:
            return saveAnnouncementFinancials(state, action);
        case SET_ANNOUNCEMENT_IPO_FPO:
            return saveAnnouncementIpoFpo(state, action);
        case SET_ANNOUNCEMENT_NEPSE_CIRCULAR:
            return saveAnnouncementNepseCircular(state, action);
        case SET_ANNOUNCEMENT_RIGHT_SHARES:
            return saveAnnouncementRightShares(state, action);

        case SET_ACTIVE_COMPARATIVE_VIEW:
            return saveComparativeActiveView(state, action);
        case SAVE_COMPARATIVE_DATA:
            return saveComparativeData(state, action);
        case SAVE_COMPARATIVE_VIEW:
            return saveComparativeView(state, action);

        case SET_ACTIVE_EQUITY:
            return saveActiveEquity(state, action);
        case SAVE_EQUITY_FINANCIALS:
            return saveEquityFinancial(state, action);
        case SAVE_EQUITY_TIME_SERIES:
            return saveEquityTimeSeries(state, action);
        case SAVE_EQUITY_TEARSHEET:
            return saveEquityTearsheet(state, action);
        case SAVE_EQUITY_PRICE_ACTIONS:
            return saveEquityPriceActions(state, action);
        case SAVE_EQUITY_KEY_FINANCIALS:
            return saveEquityKeyFinancial(state, action);
        case SAVE_EQUITY_ANNOUNCEMENT:
            return saveEquityAnnouncement(state, action);
        case SAVE_EQUITY_DIVIDEND_HISTORY:
            return saveEquityDividentHistory(state, action);

        case SET_OVERVIEW_ACTIVE_SECTOR:
            return setOverviewActiveSector(state, action);
        case SAVE_OVERVIEW_SECTOR_DATA:
            return saveOverviewSectorData(state, action);
        case SAVE_OVERVIEW_INDICES_DATA:
            return saveOverviewIndicesData(state, action);
        case SAVE_OVERVIEW_PRICE_ACTIONS:
            return saveOverviewPriceActions(state, action);
        case SAVE_OVERVIEW_TOP_BROKERS:
            return saveOverviewTopBrokers(state, action);
        case SAVE_OVERVIEW_TOP_LOSERS_GAINERS:
            return saveOverviewTopLosersGainers(state, action);
        case SAVE_OVERVIEW_ACTIVE_TURNOVER:
            return saveOverviewActiveTurnover(state, action);
        case SAVE_OVERVIEW_TIME_SERIES:
            return saveOverviewTimeSeries(state, action);

        case SAVE_HOMESCREEN_TODAYS_EVENTS:
            return saveHomeScreenTodaysEvents(state, action);
        case SAVE_HOMESCREEN_TODAYS_ANNOUNCEMENT:
            return saveHomeScreenTodaysAnnouncements(state, action);
        case SAVE_HOMESCREEN_UPCOMING_EVENTS:
            return saveHomeScreenUpcomingEvents(state, action);
        case SAVE_HOMESCREEN_MOVERS:
            return saveHomeMovers(state, action);
        case SAVE_HOMESCREEN_PORTFOLIO:
            return saveHomePortfolio(state, action);

        case SAVE_HOMESCREEN_WATCHLIST_TICKERS:
            return saveWatchListTickers(state, action);
        case SAVE_HOMESCREEN_WATCHLIST:
            return saveWatchList(state, action);
        default:
            return state;
    }
};

export default domainDataReducer;



// WEBPACK FOOTER //
// ./src/common/reducers/domainData.js